

























































































































































































































import Vue from "vue";
import HttpClientFactory from "../../services/HttpClientFactory";
import HttpClient from "../../services/HttpClient";
import Invoice from "../../types/invoices/Invoice";
import ApiInvoice from "../../types/invoices/api/ApiInvoice";
import InvoiceIndexResponse from "../../types/invoices/api/InvoiceIndexResponse";
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import { formatAsDate, formatAsMoney } from "../../helpers/format";
import BaseAlert from "../../components/black_dashboard_pro/BaseAlert.vue";
import InvoicedAmountsGraph from "./InvoiceMetrics/InvoicedAmountsGraph.vue";
import currency from "currency.js";
import swal from "sweetalert2";
import InvoiceMetrics from "./InvoiceMetrics/InvoiceMetrics.vue";

export default Vue.extend({
  components: {
    // @ts-ignore
    BaseAlert,
    InvoiceMetrics,
    InvoicedAmountsGraph,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
  },
  data() {
    return {
      alert: false,
      msgAlert: "",
      url: "",
      signInvoice: true,
      httpClient: {} as HttpClient,
      tableData: [] as Partial<Invoice>[],
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.getInvoices();
  },
  methods: {
    getInvoiceStatusBadgeType(status: string) {
      switch (status) {
        case "draft":
          return "info";
        case "sent":
          return "success";
        case "pending":
          return "warning";
        case "deleted":
          return "danger";
        case "failed":
          return "danger";
        default:
          return "info";
      }
    },
    moneyFormatter(row: any, cellValue: any, column: any) {
      return formatAsMoney(column, "EUR", this.$i18n.i18next.language);
    },
    dateFormatter(row: any, cellValue: any, column: any) {
      return formatAsDate(column);
    },
    getInvoices() {
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/invoice/v1/view?limit=5")
        .then((res: any) => {
          if (res.data.length !== 0) {
            const apiInvoices: InvoiceIndexResponse = res.data;

            const transformedInvoices = apiInvoices.map(
              (invoiceData: ApiInvoice) => {
                return {
                  receiver: invoiceData.receiver,
                  invoiceNumber: invoiceData.invoiceNumber,
                  invoiceDateAt: invoiceData.invoiceDateAt,
                  dueDateAt: invoiceData.dueDateAt,
                  grandTotal: currency(invoiceData.grandTotal, {
                    fromCents: true,
                    precision: 2,
                  }),
                  id: invoiceData.id,
                  priceWithOutVatAndTaxes: currency(
                    invoiceData.priceWithoutVatAndTaxes,
                    { fromCents: true, precision: 2 }
                  ),
                  status: invoiceData.status,
                };
              }
            );

            this.tableData = transformedInvoices.filter(
              (invoice) => invoice.status !== "deleted"
            );
          }
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("invoices:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
    async deleteInvoice(id: number) {
      const result = await swal.fire({
        title: this.$t("invoices:view.swal.title"),
        text: this.$t("invoices:view.swal.sub_title"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "<span data-test='confirm-button-swal-yes'>" +
          this.$t(`invoices:view.swal.yes`) +
          "</span>",
        cancelButtonText:
          "<span data-test='cancel-button-swal-no'>" +
          this.$t("invoices:view.swal.no") +
          "</span>",
        customClass: {
          confirmButton: "btn btn-next btn-wd btn-primary",
          cancelButton: "btn btn-next btn-wd btn-danger",
        },
        buttonsStyling: false,
      });

      if (result.isDismissed) {
        return false;
      }

      if (result.isConfirmed) {
        try {
          const res = await this.httpClient.delete(
            process.env.VUE_APP_BACKEND_ENDPOINT + `/invoice/v1/${id}`
          );
          const success: any = {
            text: this.$t("invoices:deleted"),
            type: "success",
          };
          this.$notify(success);

          const responseDelete: ApiInvoice = res.data;
          const findInvoiceIndex = this.tableData.findIndex(
            (element: any) => element.id === responseDelete.id
          );
          this.tableData.splice(findInvoiceIndex, 1);
          this.getInvoices();
        } catch (e) {
          const error: any = {
            text: this.$t("invoices:error"),
            type: "error",
          };
          this.$notify(error);
        }
      }
      return result;
    },
    editInvoice(id: number) {
      this.$router.push("./invoices/" + id + "/edit");
    },
    transformToMonetaryUnit(number: number) {
      return number / 100;
    },
    forceFileDownload(response: any, filename: string) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = new Blob([response], { type: "octet/stream" });
      const blob = window.URL.createObjectURL(url);
      a.href = blob;
      a.download = filename.toString();
      a.click();
      window.URL.revokeObjectURL(blob);
    },
    async downloadInvoice(id: number) {
      try {
        const res = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT + `/invoice/v1/${id}/facturae`
        );

        const contentDisposition = res.headers["content-disposition"];
        const filename = contentDisposition
          .split(";")[1]
          .split("=")[1]

        this.forceFileDownload(res.data, filename);
        const success: any = {
          text: this.$t("dashboard:downloading"),
          type: "info",
        };
        this.$notify(success);
      } catch (e) {
        const code = e.response.data.code;
        const receiverId = e.response.data.receiverId;
        if (e.response.status === 403 && code.includes("receiver")) {
          this.url = `/receivers/${receiverId}/edit`;
          this.msgAlert = this.$t(`invoices:errors.receiver.${code}`);
          this.alert = true;
          return;
        }
        if (e.response.status === 403 && code.includes("sender")) {
          this.url = `/profile`;
          this.msgAlert = this.$t(`invoices:errors.sender.${code}`);
          this.alert = true;
          return;
        }
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
    async showAutofirmaNotFoundDialog() {
      const result = await swal.fire({
        title: this.$t("invoices:autofirma.not_found"),
        text: this.$t("invoices:autofirma.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "<span data-test='download-autofirma-button'>" +
          this.$t("invoices:autofirma.download_autofirma") +
          "</span>",
        cancelButtonText:
          "<span data-test='close-menssage-autofirma-button'>" +
          this.$t("invoices:autofirma.close_message") +
          "</span>",
        customClass: {
          confirmButton: "btn btn-next btn-wd btn-primary",
          cancelButton: "btn btn-next btn-wd btn-danger",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        window.open(
          "http://firmaelectronica.gob.es/Home/Descargas.html",
          "_blank"
        );
      }
    },
    async sendInvoice(invoice: ApiInvoice) {
      if (!invoice.receiver.deliveryType) {
        this.url = `/receivers/${invoice.receiver.id}/edit`;
        this.msgAlert = this.$t(
          `invoices:errors.receiver.receiver_delivery_type_required`
        );
        this.alert = true;
        return;
      }

      if (invoice.receiver.deliveryType === "FACe") {
        return await this.sendInvoiceToFace(invoice);
      }

      if (invoice.receiver.deliveryType === "FACeB2B") {
        return await this.sendInvoiceToFaceB2B(invoice);
      }
    },
    async sendInvoiceToFaceB2B(invoice: ApiInvoice) {
      try {
        const res = await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/invoice/v1/${invoice.id}/deliver`
        );
        const info: any = {
          text: this.$t("invoices:sending"),
          type: "info",
        };
        this.$notify(info);
        const apiInvoice: ApiInvoice = res.data;
        const transformedData = {
          receiver: apiInvoice.receiver,
          invoiceNumber: apiInvoice.invoiceNumber,
          invoiceDateAt: formatAsDate(apiInvoice.invoiceDateAt),
          dueDateAt: formatAsDate(apiInvoice.dueDateAt),
          grandTotal: currency(apiInvoice.grandTotal, {
            fromCents: true,
            precision: 2,
          }),
          id: apiInvoice.id,
          priceWithOutVatAndTaxes: currency(
            apiInvoice.priceWithoutVatAndTaxes,
            { fromCents: true, precision: 2 }
          ),
          status: apiInvoice.status,
        };
        const findInvoiceIndex = this.tableData.findIndex(
          (element: any) => element.id === apiInvoice.id
        );
        this.tableData.splice(findInvoiceIndex, 1, transformedData);
        const success: any = {
          text: this.$t("invoices:sent"),
          type: "success",
        };
        this.$notify(success);
      } catch (e) {
        this.getInvoices();
        this.showSendInvoceErrors(e, invoice.receiver.id);
      }
    },
    async sendInvoiceToFace(invoice: ApiInvoice) {
      await swal.fire({
        title: this.$t("invoices:sending"),
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: async () => {
          try {
            swal.showLoading();
            const { data } = await this.httpClient.get(
              process.env.VUE_APP_BACKEND_ENDPOINT +
                `/invoice/v1/${invoice.id}/facturae`
            );
            //@ts-ignore
            window.MiniApplet.sign(
              //@ts-ignore
              window.MiniApplet.getBase64FromText(data),
              "SHA1withRSA",
              "FacturaE",
              "filters=nonexpired:;issuer.rfc2254:(|(O=FNMT)(O=FNMT-RCM))",
              async (contentXml: any) => {
                try {
                  const { data } = await this.httpClient.post(
                    process.env.VUE_APP_BACKEND_ENDPOINT +
                      `/invoice/v1/${invoice.id}/send-signed-invoice`,
                    {
                      mimeType: "application/xml",
                      content: decodeURIComponent(
                        escape(window.atob(contentXml))
                      ),
                    }
                  );

                  const apiInvoice: ApiInvoice = data;
                  const viewData = {
                    receiver: apiInvoice.receiver,
                    invoiceNumber: apiInvoice.invoiceNumber,
                    invoiceDateAt: formatAsDate(apiInvoice.invoiceDateAt),
                    dueDateAt: formatAsDate(apiInvoice.dueDateAt),
                    grandTotal: currency(apiInvoice.grandTotal, {
                      fromCents: true,
                      precision: 2,
                    }),
                    id: apiInvoice.id,
                    priceWithOutVatAndTaxes: currency(
                      apiInvoice.priceWithoutVatAndTaxes,
                      { fromCents: true, precision: 2 }
                    ),
                    status: apiInvoice.status,
                  };
                  const findInvoiceIndex = this.tableData.findIndex(
                    (element: any) => element.id === apiInvoice.id
                  );
                  this.tableData.splice(findInvoiceIndex, 1, viewData);
                  swal.close();
                  const success: any = {
                    text: this.$t("invoices:sent"),
                    type: "success",
                  };
                  this.$notify(success);
                } catch (e) {
                  swal.close();
                  if (e.response) {
                    this.getInvoices();
                    this.showSendInvoceErrors(e, invoice.receiver.id);
                  }
                }
              },
              async (type: string, message: string) => {
                swal.close();

                if (invoice.status === "sent") {
                  const warn: any = {
                    text: this.$t("invoices:invoice_already_sent"),
                    type: "warn",
                  };
                  this.$notify(warn);
                }

                if (
                  type ===
                  "es.gob.afirma.standalone.ApplicationNotFoundException"
                ) {
                  await this.showAutofirmaNotFoundDialog();
                }
              }
            );
          } catch (e) {
            swal.close();
            if (e.response) {
              this.getInvoices();
              this.showSendInvoceErrors(e, invoice.receiver.id);
            }
          }
        },
      });
    },
    showSendInvoceErrors(e: any, receiverId: number | null) {
      const code = e.response.data.code;

      if (e.response.status === 400) {
        const error: any = {
          title: this.$t(`invoiceDeliveryError:${e.response.data.code}`),
          text: e.response.data.description,
          type: "error",
        };
        this.$notify(error);
        return;
      }
      if (e.response.status === 403 && code.includes("sender")) {
        this.url = `/profile`;
        this.msgAlert = this.$t(`invoices:errors.sender.${code}`);
        this.alert = true;
        return;
      }
      if (e.response.status === 403 && code.includes("receiver")) {
        this.url = `/receivers/${receiverId}/edit`;
        this.msgAlert = this.$t(`invoices:errors.receiver.${code}`);
        this.alert = true;
        return;
      }
      const errorCode = e.response.data.code ?? e.response.status;
      const error: any = {
        text: this.$t(`invoices:errors.${errorCode}`),
        type: "error",
      };
      this.$notify(error);
    },
  },
});
